<div class="popup-container tlms-popup">
  <header>
    <div class="header" style="display:block">Delete</div>
    <button class="close" style="top:-3px" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <ng-container>
    <div style="padding: 16px 24px 16px 24px;">
      <div class="col-12" style="width: 100%;">
        <div class="upload">
          <label class="catlabel">Are you sure you want to delete this task?</label>
        </div>
      </div>
    </div>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
      <button (click)="onNoClick()" class="mCancel"> CANCEL
      </button>
      <button class="taskm-submit" style="display: inline" (click)="saveClick()">
        CONFIRM
      </button>
    </div>
  </ng-container>
</div>